"use strict";
function createRange(start, end) {
    var range = [];
    for (var i = start; i <= end; i++) {
        range.push(i);
    }
    return range;
}
exports.createRange = createRange;
//# sourceMappingURL=ultimate-pagination-utils.js.map